
import React, { useEffect } from 'react'
import { Button, Table, Form, Input, Space, Popconfirm, Modal, Select } from 'antd'
//导入图标
import { PlusOutlined } from '@ant-design/icons'

//查询
import { searchFun } from '@/utils'

//导入样式
import '@/scss/common.scss'

//新增
import ShedsNewly from './add'
//编辑
import ShedsRevise from './revise'
//查看
import ShedsSeedata from './seedata'
//绑定传感器
import Shedstransducer from './bindcode'
//解绑
import Shedsup from './jiebang'

//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'
import moment from 'moment'

const Sheds = () => {
    //mobx
    const { ShedsStore } = useStore()
    const [form] = Form.useForm()

    //查询
    const onFinish = async (values) => {
        let data = searchFun(values)
        runInAction(() => {
            set(ShedsStore, { filter: data.content })
            set(ShedsStore, { op: data.rule })
            set(ShedsStore, { page: 1 })
        })
        await ShedsStore.getDataList()
    }
    //重置
    const onReset = () => {
        form.resetFields()
    }
    //获得table数据
    useEffect(() => {
        runInAction(() => {
            set(ShedsStore, { filter: '' })
            set(ShedsStore, { op: '' })
            set(ShedsStore, { page: 1 })
            set(ShedsStore, { limit: 10 })
        })
        ShedsStore.getDataList()
        // eslint-disable-next-line
    }, [])

    //弹出新增角色框
    const getAddRole = (title) => {
        runInAction(() => {
            set(ShedsStore, { isAshow: true })
            set(ShedsStore, { title: title })
        })
    }
    //弹出框按钮关闭
    const handleAddRole = () => {
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
            set(ShedsStore, { selectdata:[] })
        })
    }
    //编辑按钮
    const revise = (item, title) => {
        let items = toJS(item)
        if (items.start_date) {
            items.start_date = moment(items.start_date, 'YYYY-MM-DD')
        }
        if (items.end_date) {
            items.end_date = moment(items.end_date, 'YYYY-MM-DD')
        }
        runInAction(() => {
            set(ShedsStore, { isRevise: true })
            set(ShedsStore, { valueData: items })
            //当前id  为编辑的提交传
            set(ShedsStore, { dqid: items.id })
            set(ShedsStore, { isAshow: true })
            set(ShedsStore, { title: title })
        })
    }
    const seedata = (item, title) => {
        let items = toJS(item)
        runInAction(() => {
            set(ShedsStore, { seevalue: items })
            set(ShedsStore, { title: title })
            set(ShedsStore, { isAshow: true })
        })
    }
    //分页控制
    const onPageChange = (page, pageSize) => {
        runInAction(() => {
            set(ShedsStore, { page: page })
            set(ShedsStore, { limit: pageSize })
        })
        ShedsStore.getDataList()
    }
    //删除
    const confirm = async (item) => {
        let id = toJS(item).id
        toJS(ShedsStore.dataList).filter(item => item.id !== id)
        await ShedsStore.getDeleteButtom(id)
    }
    //下拉框
    const { Option } = Select;

    //传感器
    const gettransducer = (item, title) => {
        ShedsStore.newselect()
        runInAction(() => {
            set(ShedsStore, { isAshow: true })
            set(ShedsStore, { title: title })
            set(ShedsStore, { dqid: item.id })
        })
    }
    //解绑
    const jiebang = (item, title) => {
        runInAction(() => {
            set(ShedsStore, { isAshow: true })
            set(ShedsStore, { title: title })
            set(ShedsStore, { dqid: item.id })
        })
    }
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
        },
        {
            title: '名称',
            dataIndex: 'house_name',
        },
        {
            title: '面积',
            dataIndex: 'area',
        },
        {
            title: '种植品种',
            dataIndex: 'plant',
        },
        {
            title: '设备编号',
            dataIndex: 'code',
        },
        {
            title: '经度',
            dataIndex: 'lat',
        },
        {
            title: '维度',
            dataIndex: 'lng',
        },
        {
            title: '开始时间',
            dataIndex: 'start_date',
        },
        {
            title: '结束时间',
            dataIndex: 'end_date',
        },
        {
            title: '操作',
            render: (item) => (
                <Space size="middle">
                    <a onClick={() => seedata(item, '查看数据')}>查看</a>
                    <a onClick={() => revise(item, '编辑')}>编辑</a>
                    <Popconfirm
                        title="是否删除"
                        onConfirm={() => { confirm(item) }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <a href="#">删除</a>
                    </Popconfirm>
                    {
                        item.sdcode ? (
                            <a onClick={() => jiebang(item, '解绑')}>解绑</a>
                        ) : (
                            <a onClick={() => gettransducer(item, '设备绑定')}>设备绑定</a>
                        )
                    }


                </Space>
            ),
        },
    ]
    return (
        <>
            <div className='topTitle'>
                <div className='titleBtn'>棚室管理</div>
            </div>
            <div className='searchBox'>
                <Button type="primary" icon={<PlusOutlined />} className='addTitle' onClick={() => getAddRole('添加棚室')}>添加棚室</Button>
                <div className='TableInput'>
                    <Form layout="inline" onFinish={onFinish} form={form}>
                        <Form.Item label='关键词'>
                            <Input.Group compact>
                                <Form.Item name='select'>
                                    <Select placeholder="请选择" style={{ width: '100px' }}>
                                        <Option value="house_name">名称</Option>
                                        <Option value="area">面积</Option>
                                        <Option value="type">类型</Option>
                                        <Option value="plant">种植品种</Option>
                                        <Option value="code">设备编号</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name='keyword'>
                                    <Input placeholder="请输入内容" style={{ width: '260px' }} />
                                </Form.Item>
                            </Input.Group>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                                重置
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className='contextNr'>
                <Table rowKey={record => record.id} columns={columns} dataSource={ShedsStore.dataList} className='table-box' pagination={{
                    position: ['bottomRight'],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ['10', '20', '30'],
                    pageSize: ShedsStore.limit,
                    current: ShedsStore.page,
                    total: ShedsStore.total,
                    onChange: (page, pageSize) => onPageChange(page, pageSize),
                }} />
                <Modal
                    title={ShedsStore.title}
                    width="700px"
                    key={new Date()}
                    open={ShedsStore.isAshow}
                    footer={null}
                    onCancel={handleAddRole}
                    destroyOnClose={true}
                >
                    {
                        ShedsStore.title === '添加棚室' && (<ShedsNewly />)
                    }
                    {
                        ShedsStore.title === '编辑' && (<ShedsRevise />)
                    }
                    {
                        ShedsStore.title === '查看数据' && (<ShedsSeedata />)
                    }
                    {
                        ShedsStore.title === '设备绑定' && (<Shedstransducer />)
                    }
                    {
                        ShedsStore.title === '解绑' && (<Shedsup />)
                    }
                </Modal>
            </div>
        </>
    )
}

export default observer(Sheds)